module.exports = __webpack_public_path__ + "img/white-dot.8111027.png";